var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOilTank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 59,
    viewBox: "0 0 100 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 53,
    width: 100,
    height: 6,
    fill: "#29ABE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 92,
    height: 48,
    rx: 15,
    fill: "#F7931E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 10,
    height: 3,
    fill: "#29ABE2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 63.5,
    y1: 3,
    x2: 63.5,
    y2: 36,
    stroke: "#29ABE2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 75.5,
    y1: 3,
    x2: 75.5,
    y2: 36,
    stroke: "#29ABE2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 7.5,
    x2: 75,
    y2: 7.5,
    stroke: "#29ABE2"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 15.5,
    x2: 75,
    y2: 15.5,
    stroke: "#29ABE2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 22.5,
    x2: 75,
    y2: 22.5,
    stroke: "#29ABE2"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 28.5,
    x2: 75,
    y2: 28.5,
    stroke: "#29ABE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5722 26.0711C23.0067 24.6948 26.5035 19 26.5035 19C26.5035 19 29.9902 24.6948 30.4347 26.0711C30.8793 27.4475 31.446 29.7781 30.4347 31.5369C29.4251 33.2928 26.4985 32.9781 26.4985 32.9781C26.4985 32.9781 23.4683 33.0434 22.5722 31.5369C21.5377 29.7975 22.1377 27.4475 22.5722 26.0711Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilTank);
export default __webpack_public_path__ + "static/media/OilTank.87bb9c40732464c020cd87dcced1f2ff.svg";
export { ForwardRef as ReactComponent };